import { createContext, RefObject } from 'react';

export const MenuContext = createContext<[boolean, (open: boolean) => void]>([
  false,
  () => {},
]);

export const MenuTriggerContext =
  createContext<RefObject<HTMLButtonElement> | null>(null);
